export default axios => ({
    getAll(unitId, params) {
        return axios.get(`/unit/${unitId}/sensors`, { params });
    },
    getAllGlobal(params) {
        return axios.get(`/sensors`, { params });
    },
    find(id, params) {
        return axios.get(`/sensors/${id}`, { params });
    },
    create(data, params) {
        return axios.post(`/sensors`, data, { params });
    },
    update(id, data, params) {
        return axios.put(`/sensors/${id}`, data, { params });
    },
    delete(id, params) {
        return axios.delete(`/sensors/${id}`, { params });
    },
    import(unitId, data, params) {
        return axios.post(`/unit/${unitId}/sensors/import`, data, { params });
    },
});
